// JsFromRoutes CacheKey daa0a0b94f3b37aaefb3ecca8be4c27f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/admin/reimbursement_requests'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/reimbursement_requests/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/reimbursement_requests/:id'),
}
